import React, { Children, ReactNode, useState } from "react";
import { Box, Button, MultiSelect, Text, Textarea, Title } from "@mantine/core";
import {
  MantineProvider,
  Container,
  Paper,
  Radio,
  useMantineTheme,
  Menu,
} from "@mantine/core";
import ReusableehrLayout from "../../components/ReusableehrLayout";
import SharedSectionHeader from "../../components/SharedSectionHeader";
import EhrBrandCard from "../../components/EhrBrandCard";
import { Select, Divider, SelectItem, Loader } from "@mantine/core";
import CustomInput from "../../components/CustomInput";
import { JsonInput, Input } from "@mantine/core";
import { ReactComponent as Info } from "../../assets/img/info.svg";
import Ethena from "../../assets/img/athenahealth.svg";
import Ceren from "../../assets/img/cerner.svg";
import Nextgen from "../../assets/img/nextgen.svg";
import frame from "../../assets/img/Frame 427321617.svg";
import dexcom from "../../assets/img/Dexcom.svg";
import oura from "../../assets/img/Oura.svg";
import fitbit from "../../assets/img/fitbit.svg";
import polar from "../../assets/img/polar.svg";
import gfit from "../../assets/img/Googlefit.svg";
import { useMedplum } from "@medplum/react";
import { showNotification } from "@mantine/notifications";
import { normalizeErrorString } from "@medplum/core";
import { getProjectId } from "../../utils";
import { useNavigate, useParams } from "react-router-dom";
import { Loading, StatusBadge } from "@medplum/react";
import meditech from "../../assets/img/meditech.svg";
import veradigm from "../../assets/img/vardigm.svg";
import eclinical from "../../assets/img/eclinical.svg";
import apple from "../../assets/img/apple.svg";
import omron from "../../assets/img/omronLogo.png";
import withing from "../../assets/img/withingsLogo.png";
import strava from "../../assets/img/stravaLogo.png";
import hammer from "../../assets/img/hammer.svg";
import noise from "../../assets/img/noise.svg";
import garmin from "../../assets/img/garminlogo.png";
import iHealthLogo from "../../assets/img/ihealth.png";
import LabelMenue from "../../components/MenuLabel";
interface Props {
  ehrorwear: any;
  wear: boolean;
}

const EhrConnect: React.FC<Props> = ({ ehrorwear, wear }) => {
  const data: SelectItem[] = [
    { value: "Patient", label: "Patient Standalone" },
    { value: "Practioner", label: "Practitioner standalone" },
    { value: "Backend", label: "Backend System" },
  ];
  const [isFetching, setIsFetching] = useState<boolean>(true);
  const Heading = (
    <>
      {wear ? "EHR Credentials" : "Wear Credentials"}
      {wear ? (
        <span style={{ color: "red" }}> *</span>
      ) : (
        <span style={{ color: "red" }}> *</span>
      )}{" "}
    </>
  );
  const [applicationName, setApplicationName] = useState<string>("");
  const [disableButton,setDisableButton]=useState(false);
  const [description, setDescription] = useState<string>("");
  const [launchType, setLaunchType] = useState<string>("");
  const [serverURI, setServerURI] = useState<string>("");
  const [grantType, setGrantType] = useState<string>("");
  const [authURI, setAuthURI] = useState<string>("");
  const [tenantID, setTenantID] = useState<string>("");
  const [ehrClientID, setEhrClientID] = useState<string>("");
  const [ehrClientSecret, setEhrClientSecret] = useState<string>("");
  const [scope, setScope] = useState<string>("");
  const [userInfo, setUserinfo] = useState<string>("");
  const [selectedValue, setSelectedValue] = useState("");
  const [TokenUrl, setTokenUrl] = useState<string>("");
  const handleRadioChange = (value: any) => {
    setSelectedValue(value);
  };
  const areFieldsEmpty = () => {
    const emptyFields = [];
    if (!applicationName) emptyFields.push("Application Name");
    if (!description) emptyFields.push("Description");
    if (!authURI) emptyFields.push("Auth Url");
    if (!tenantID) emptyFields.push("Redirect Url");
    if (!ehrClientID) emptyFields.push("EHR Client ID");
    if (!ehrClientSecret) emptyFields.push("EHR Client Secret");
    if (!scope) emptyFields.push("Scope");
    if (!userInfo) emptyFields.push("User Info");
    if (!selectedValue) emptyFields.push("Credentials");
    if (!TokenUrl) emptyFields.push("Token Url");

    return emptyFields;
  };
  const { clientId, resourceType }: any = useParams();

  const [clientDetails, setClientDetails] = useState<any>({});
  const medplum = useMedplum();
  const projectId = getProjectId(medplum);
  const navigate = useNavigate();
  const [selectedBrand, setSelectedBrand] = useState<string>("");
  const [clientType, setClientType] = useState<string>(
    wear ? "EHR" : "Wearable"
  );

  const handleBrandSelect = (brand: string) => {
    setSelectedBrand((prev) => (prev === brand ? "" : brand));
  };
  const handledisableBrandSelect = () => {
    // this function is provided as we have few disabled cards so if user wans to select it wont get selected
  };

  const createClient = async () => {
    const body = {
      name: applicationName,
      description: description,
      redirectUri: tenantID,
      accessPolicy: "",
    };

    try {
      const createdClient = await medplum.post(
        "admin/projects/" + projectId + "/client",
        body
      );
      medplum.invalidateSearches("ClientApplication");
      medplum.invalidateSearches("ProjectMembership");
      setIsFetching(false);
      return createdClient;
    } catch (err) {
      showNotification({
        color: "red",
        message: normalizeErrorString(err),
        autoClose: true,
      });
      setIsFetching(false);
    }
  };

  const onCreateButtonClick = async (event: any) => {
    setDisableButton(true)
   
    const emptyFields = areFieldsEmpty();
    if (emptyFields.length > 0) {
      setDisableButton(false)
     
      showNotification({
        color: "red",
        message: `Please fill in the following fields: ${emptyFields.join(
          ", "
        )}`,
        autoClose: true,
      });
     
      return;
    }
    
 
    const requiredFields = [
      "scope",
      "clientType",
      "integrationType",
      "environment",
    ];
    if (clientType === "EHR" || clientType === "WEAR") {
      requiredFields.push("launchType");
    }

    const data: any = {
      additionalData: {
        scope: scope,
        clientType: clientType,
        integrationType: selectedBrand,
        environment: selectedValue,
        launchType: launchType,
      },
    };

    const missingFields = requiredFields.filter(
      (field) => !data.additionalData?.[field]
    );

    if (missingFields.length > 0) {
      
      setDisableButton(false)
    
      showNotification({
        color: "red",
        message: `Please fill in the required fields: ${missingFields.join(
          ", "
        )}`,
        autoClose: true,
      });
      return;
    }
   

    const clientExtension = [
      {
        url: "additionalFields",
        extension: requiredFields.map((field) => ({
          url: field,
          valueString: data.additionalData[field],
        })),
      },
    ];

    let clientData;
     setIsFetching(false);

    if (!clientId) {
      clientData = await createClient();
    } else {
      clientData = clientDetails;
    }

    clientData.meta.extension = clientExtension;
    clientData.identityProvider = {
      authorizeUrl: authURI,
      tokenUrl: TokenUrl,
      userInfoUrl: userInfo,
      clientId: ehrClientID,
      clientSecret: ehrClientSecret,
    };
    clientData.jwksUri = serverURI;

    if (clientData.additionalData) {
      clientData.additionalData = undefined;
    }

    medplum
      .updateResource(clientData)
      .then((res) => {
        setClientDetails({});
        showNotification({
          color: "green",
          message: "Success",
          autoClose: true,
        });
        if (clientId) {
          navigate(`/client/details/${resourceType}/${clientId}`);
        } else {
          navigate(`/client/details/${res.resourceType}/${res.id}`);
        }
      })
      .catch((err) => {
        showNotification({
          color: "red",
          message: normalizeErrorString(err),
          autoClose: true,
        });
        setDisableButton(false)
        setIsFetching(true);
      });
  };
  const onCancelClick = () => {
    navigate(-1);
  };
  const handleSelect = (value: string) => {
    setLaunchType(value);
  };

  return (
    <Box>
      {" "}
      {!isFetching && (
        <Box
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <Loader />
        </Box>
      )}
      <form>
        <ReusableehrLayout>
          <SharedSectionHeader
            Heading="General Information"
            subHeading="Application and description to easily identify each of your application."
          >
            {" "}
            <Box sx={{ marginBottom: "24px" }}>
              <Text
                sx={{
                  fontWeight: 600,
                  fontSize: "14px",
                  lineHeight: "21px",
                  marginBottom: "5px",
                }}
              >
                Application Name <span style={{ color: "red" }}>*</span>
              </Text>
              <Box
                sx={{
                  height: "50px",
                  borderRadius: "5px",
                }}
              >
                <input
                  type="text"
                  placeholder="Enter Application Name"
                  value={applicationName}
                  onChange={(e) => setApplicationName(e.target.value)}
                  style={{
                    height: "50px",
                    width: "100%",
                    padding: "16px",
                    fontSize: "14px",
                    fontWeight: 400,
                    lineHeight: "22px",
                    border: "1px solid #E5E5E5",

                    outline: "none",

                    borderRadius: "8px",
                  }}
                />
              </Box>
            </Box>
            <Box>
              <Text
                sx={{
                  fontWeight: 600,
                  fontSize: "14px",
                  lineHeight: "21px",
                  marginBottom: "5px",
                }}
              >
                Description <span style={{ color: "red" }}>*</span>
              </Text>
              <Box
                sx={{
                  height: "168px",
                  borderRadius: "5px",
                }}
              >
                <textarea
                  placeholder="Description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  style={{
                    height: "168px",
                    width: "100%",
                    padding: "16px",
                    fontSize: "14px",
                    fontWeight: 400,
                    lineHeight: "22px",
                    border: "1px solid #E5E5E5",
                    outline: "none",
                    resize: "none",

                    borderRadius: "8px",

                    wordBreak: "break-word",
                  }}
                />
              </Box>
            </Box>
          </SharedSectionHeader>
          <SharedSectionHeader
            Heading={ehrorwear}
            subHeading={`Configure the ${
              wear ? "EHR" : "Wear"
            } by creating new or using  ${
              wear ? "EHR" : "Wear"
            } Credentials to connect ${wear ? "EHR's" : "Wear's"} API’s`}
          >
            <Box
              sx={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}
            >
              {wear ? (
                <>
                  <Box sx={{ padding: "16px" }}>
                    <EhrBrandCard
                      BrandName="EPIC"
                      disableButton={false}
                      onclick={handleBrandSelect}
                      isSelected={selectedBrand === "EPIC"}
                    >
                      <Box>
                        <img src={frame} />
                      </Box>
                    </EhrBrandCard>
                  </Box>
                  <Box sx={{ padding: "16px" }}>
                    <EhrBrandCard
                      BrandName="Cerner"
                      disableButton={false}
                      onclick={handleBrandSelect}
                      isSelected={selectedBrand === "Cerner"}
                    >
                      <Box>
                        <img src={Ceren} />
                      </Box>
                    </EhrBrandCard>
                  </Box>
                  <Box sx={{ padding: "16px" }}>
                    <EhrBrandCard
                      BrandName="AthenaHealth"
                      disableButton={false}
                      onclick={handleBrandSelect}
                      isSelected={selectedBrand === "AthenaHealth"}
                    >
                      <Box sx={{ width: "129px", height: "43px" }}>
                        <img
                          src={Ethena}
                          style={{ width: "129px", height: "43px" }}
                        />
                      </Box>
                    </EhrBrandCard>
                  </Box>
                  <Box sx={{ padding: "16px" }}>
                    <EhrBrandCard
                      BrandName="eClinicalWorks"
                      disableButton={false}
                      onclick={handleBrandSelect}
                      isSelected={selectedBrand === "eClinicalWorks"}
                    >
                      <Box sx={{ width: "129px", height: "43px" }}>
                        <img
                          src={eclinical}
                          style={{ width: "129px", height: "43px" }}
                        />
                      </Box>
                    </EhrBrandCard>
                  </Box>
                  <Box sx={{ padding: "16px" }}>
                    <EhrBrandCard
                      BrandName="NextGen"
                      disableButton={false}
                      onclick={handleBrandSelect}
                      isSelected={selectedBrand === "NextGen"}
                    >
                      <Box sx={{ width: "129px", height: "43px" }}>
                        <img
                          src={Nextgen}
                          style={{ width: "129px", height: "43px" }}
                        />
                      </Box>
                    </EhrBrandCard>
                  </Box>
                  <Box sx={{ padding: "16px" }}>
                    <EhrBrandCard
                      BrandName="AthenaOne"
                      disableButton={false}
                      onclick={handleBrandSelect}
                      isSelected={selectedBrand === "AthenaOne"}
                    >
                      <Box sx={{ width: "129px", height: "43px" }}>
                        <img
                          src={Ethena}
                          style={{ width: "129px", height: "43px" }}
                        />
                      </Box>
                    </EhrBrandCard>
                  </Box>
                  <Box sx={{ padding: "16px" }}>
                    <EhrBrandCard
                      BrandName="MediTech"
                      disableButton={true}
                      onclick={handledisableBrandSelect}
                      isSelected={selectedBrand === "MediTech"}
                    >
                      <Box sx={{ width: "129px", height: "43px" }}>
                        <img src={meditech} />
                      </Box>
                    </EhrBrandCard>
                  </Box>
                  <Box sx={{ padding: "16px" }}>
                    <EhrBrandCard
                      BrandName="Veradigm"
                      disableButton={false}
                      onclick={handleBrandSelect}
                      isSelected={selectedBrand === "Veradigm"}
                    >
                      <Box sx={{ width: "129px", height: "43px" }}>
                        <img
                          src={veradigm}
                          style={{ width: "129px", height: "43px" }}
                        />{" "}
                      </Box>
                    </EhrBrandCard>
                  </Box>
                </>
              ) : (
                <>
                  <Box sx={{ padding: "16px" }}>
                    <EhrBrandCard
                      BrandName="Google Fit"
                      disableButton={false}
                      onclick={handleBrandSelect}
                      isSelected={selectedBrand === "Google Fit"}
                    >
                      <Box>
                        <img src={gfit} />
                      </Box>
                    </EhrBrandCard>
                  </Box>
                  <Box sx={{ padding: "16px" }}>
                    <EhrBrandCard
                      BrandName="Dexcom"
                      disableButton={false}
                      onclick={handleBrandSelect}
                      isSelected={selectedBrand === "Dexcom"}
                    >
                      <Box>
                        {" "}
                        <img src={dexcom} />
                      </Box>
                    </EhrBrandCard>
                  </Box>
                  <Box sx={{ padding: "16px" }}>
                    <EhrBrandCard
                      BrandName="Oura"
                      disableButton={false}
                      onclick={handleBrandSelect}
                      isSelected={selectedBrand === "Oura"}
                    >
                      {/* Other SVG or component */}
                      <Box>
                        {" "}
                        <img src={oura} />
                      </Box>
                    </EhrBrandCard>
                  </Box>
                  <Box sx={{ padding: "16px" }}>
                    <EhrBrandCard
                      BrandName="Polar"
                      disableButton={false}
                      onclick={handleBrandSelect}
                      isSelected={selectedBrand === "Polar"}
                    >
                      {/* Other SVG or component */}
                      <Box>
                        <img src={polar} />
                      </Box>
                    </EhrBrandCard>
                  </Box>
                  <Box sx={{ padding: "16px" }}>
                    <EhrBrandCard
                      BrandName="Fitbit"
                      disableButton={false}
                      onclick={handleBrandSelect}
                      isSelected={selectedBrand === "Fitbit"}
                    >
                      {/* Other SVG or component */}
                      <Box>
                        <img src={fitbit} />
                      </Box>
                    </EhrBrandCard>
                  </Box>
                  <Box sx={{ padding: "16px" }}>
                    <EhrBrandCard
                      BrandName="Withings"
                      disableButton={false}
                      onclick={handleBrandSelect}
                      isSelected={selectedBrand === "Withings"}
                    >
                      {/* Other SVG or component */}
                      <Box>
                        <img src={withing} style={{ width: "150px" }} />
                      </Box>
                    </EhrBrandCard>
                  </Box>
                  <Box sx={{ padding: "16px" }}>
                    <EhrBrandCard
                      BrandName="Strava"
                      disableButton={false}
                      onclick={handleBrandSelect}
                      isSelected={selectedBrand === "Strava"}
                    >
                      {/* Other SVG or component */}
                      {/* <img src={gfit} /> */}
                      <Box>
                        <img src={strava} style={{ width: "150px" }} />
                      </Box>
                    </EhrBrandCard>
                  </Box>
                  <Box sx={{ padding: "16px" }}>
                    <EhrBrandCard
                      BrandName="Apple"
                      disableButton={false}
                      onclick={handleBrandSelect}
                      isSelected={selectedBrand === "Apple"}
                    >
                      {/* Other SVG or component */}
                      {/* <img src={gfit} /> */}
                      <Box>
                        <img src={apple} style={{ width: "60px" }} />
                      </Box>
                    </EhrBrandCard>
                  </Box>
                  <Box sx={{ padding: "16px" }}>
                    <EhrBrandCard
                      BrandName="Garmin"
                      disableButton={false}
                      onclick={handleBrandSelect}
                      isSelected={selectedBrand === "Garmin"}
                    >
                      {/* Other SVG or component */}
                      {/* <img src={gfit} /> */}
                      <Box>
                        <img src={garmin} style={{ width: "150px" }} />
                      </Box>
                    </EhrBrandCard>
                  </Box>
                  <Box sx={{ padding: "16px" }}>
                    <EhrBrandCard
                      BrandName="iHealth"
                      disableButton={false}
                      onclick={handleBrandSelect}
                      isSelected={selectedBrand === "iHealth"}
                    >
                      <Box>
                        <img
                          src={iHealthLogo}
                          style={{ width: "50px", height: "50px" }}
                        />
                      </Box>
                    </EhrBrandCard>
                  </Box>
                </>
              )}
            </Box>
          </SharedSectionHeader>
          {wear && (
            <Box sx={{ marginBottom: "24px", width: "100%" }}>
              <Box sx={{ display: "flex", flexDirection: "row" }}>
                {" "}
                <Text
                  sx={{
                    fontWeight: 600,
                    fontSize: "14px",
                    lineHeight: "21px",
                    marginBottom: "5px",
                    marginRight: "8px",
                  }}
                >
                  Launch Type <span style={{ color: "red" }}>*</span>
                </Text>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "8px",
                  }}
                ></Box>
              </Box>

              <Box
                sx={{
                  border: "1px solid #E5E5E5",
                  height: "50px",
                  borderRadius: "8px",
                }}
              >
                <Box sx={{ marginTop: "4px", width: "100%" }}>
                  <LabelMenue onSelect={handleSelect} />
                </Box>
              </Box>
            </Box>
          )}

          <SharedSectionHeader
            Heading={Heading}
            subHeading={`Configure the ${
              wear ? "EHR" : "Wear"
            } by creating new or using  ${
              wear ? "EHR" : "Wear"
            } Credentials to connect ${wear ? "EHR's" : "Wear's"} API’s`}
          >
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Box sx={{ display: "flex", flexDirection: "row" }}>
                <Radio.Group
                  sx={{
                    fontWeight: 600,
                    fontSize: "20px",
                    lineHeight: "24px",
                    display: "flex",
                    flexDirection: "row",
                    color: "#474E5B",
                  }}
                >
                  <Box
                    sx={{ padding: "0px 24px 24px 0px" }}
                    onClick={() => handleRadioChange("Sandbox")}
                  >
                    <Radio
                      value="react"
                      label="Sandbox Credentials"
                      checked={selectedValue === "Sandbox"}
                    />
                  </Box>

                  <Box
                    sx={{ padding: "0px 24px 24px 0px" }}
                    onClick={() => handleRadioChange("Production")}
                  >
                    <Radio
                      value="svelte"
                      label="Production Credentials"
                      checked={selectedValue === "Production"}
                    />
                  </Box>
                </Radio.Group>
              </Box>
              <Box sx={{ display: "flex", flexDirection: "row" }}>
                <Box
                  sx={{
                    marginBottom: "24px",
                    width: "50%",
                    marginRight: "24px",
                  }}
                >
                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                    {" "}
                    <Text
                      sx={{
                        fontWeight: 600,
                        fontSize: "14px",
                        lineHeight: "21px",
                        marginBottom: "5px",
                        marginRight: "8px",
                      }}
                    >
                      JWT Secret Token
                    </Text>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <Info />
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      height: "50px",
                      borderRadius: "5px",
                    }}
                  >
                    <input
                      type="text"
                      placeholder="Enter JWT Secret Token
"
                      value={serverURI}
                      onChange={(e) => setServerURI(e.target.value)}
                      style={{
                        height: "50px",
                        width: "100%",
                        padding: "16px",
                        fontSize: "14px",
                        fontWeight: 400,
                        lineHeight: "22px",
                        border: "1px solid #E5E5E5",

                        outline: "none",

                        borderRadius: "8px",
                      }}
                    />
                  </Box>
                </Box>
                <Box sx={{ marginBottom: "24px", width: "50%" }}>
                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                    {" "}
                    <Text
                      sx={{
                        fontWeight: 600,
                        fontSize: "14px",
                        lineHeight: "21px",
                        marginBottom: "5px",
                        marginRight: "8px",
                      }}
                    >
                      User Info URL <span style={{ color: "red" }}>*</span>
                    </Text>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <Info />
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      height: "50px",
                      borderRadius: "5px",
                    }}
                  >
                    <input
                      type="text"
                      placeholder="Enter User Info Url"
                      value={userInfo}
                      onChange={(e) => setUserinfo(e.target.value)}
                      style={{
                        height: "50px",
                        width: "100%",
                        padding: "16px",
                        fontSize: "14px",
                        fontWeight: 400,
                        lineHeight: "22px",
                        border: "1px solid #E5E5E5",

                        outline: "none",

                        borderRadius: "8px",
                      }}
                    />
                  </Box>
                </Box>
              </Box>
              <Box sx={{ display: "flex", flexDirection: "row" }}>
                <Box
                  sx={{
                    marginBottom: "24px",
                    width: "50%",
                    marginRight: "24px",
                  }}
                >
                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                    {" "}
                    <Text
                      sx={{
                        fontWeight: 600,
                        fontSize: "14px",
                        lineHeight: "21px",
                        marginBottom: "5px",
                        marginRight: "8px",
                      }}
                    >
                      Auth URL <span style={{ color: "red" }}>*</span>
                    </Text>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <Info />
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      height: "50px",
                      borderRadius: "5px",
                    }}
                  >
                    <input
                      type="text"
                      placeholder="Enter Auth Url"
                      value={authURI}
                      onChange={(e) => setAuthURI(e.target.value)}
                      style={{
                        height: "50px",
                        width: "100%",
                        padding: "16px",
                        fontSize: "14px",
                        fontWeight: 400,
                        lineHeight: "22px",
                        border: "1px solid #E5E5E5",

                        outline: "none",

                        borderRadius: "8px",
                      }}
                    />
                  </Box>
                </Box>
                <Box sx={{ marginBottom: "24px", width: "50%" }}>
                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                    {" "}
                    <Text
                      sx={{
                        fontWeight: 600,
                        fontSize: "14px",
                        lineHeight: "21px",
                        marginBottom: "5px",
                        marginRight: "8px",
                      }}
                    >
                      Redirect URL <span style={{ color: "red" }}>*</span>
                    </Text>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <Info />
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      height: "50px",
                      borderRadius: "5px",
                    }}
                  >
                    <input
                      type="text"
                      placeholder="Enter Redirect Url"
                      value={tenantID}
                      onChange={(e) => setTenantID(e.target.value)}
                      style={{
                        height: "50px",
                        width: "100%",
                        padding: "16px",
                        fontSize: "14px",
                        fontWeight: 400,
                        lineHeight: "22px",
                        border: "1px solid #E5E5E5",

                        outline: "none",

                        borderRadius: "8px",
                      }}
                    />
                  </Box>
                </Box>
              </Box>
              <Box sx={{ display: "flex", flexDirection: "row" }}>
                <Box
                  sx={{
                    marginBottom: "24px",
                    width: "50%",
                    marginRight: "24px",
                  }}
                >
                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                    {" "}
                    <Text
                      sx={{
                        fontWeight: 600,
                        fontSize: "14px",
                        lineHeight: "21px",
                        marginBottom: "5px",
                        marginRight: "8px",
                      }}
                    >
                      EHR Client ID <span style={{ color: "red" }}>*</span>
                    </Text>
                  </Box>

                  <Box
                    sx={{
                      // border: "1px solid #E5E5E5",
                      height: "50px",
                      borderRadius: "5px",
                    }}
                  >
                    <input
                      type="text"
                      placeholder="Enter EHR Client ID"
                      value={ehrClientID}
                      onChange={(e) => setEhrClientID(e.target.value)}
                      style={{
                        height: "50px",
                        width: "100%",
                        padding: "16px",
                        fontSize: "14px",
                        fontWeight: 400,
                        lineHeight: "22px",
                        border: "1px solid #E5E5E5",

                        outline: "none",

                        borderRadius: "8px",
                      }}
                    />
                  </Box>
                </Box>
                <Box sx={{ marginBottom: "24px", width: "50%" }}>
                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                    {" "}
                    <Text
                      sx={{
                        fontWeight: 600,
                        fontSize: "14px",
                        lineHeight: "21px",
                        marginBottom: "5px",
                        marginRight: "8px",
                      }}
                    >
                      EHR Client Secret <span style={{ color: "red" }}>*</span>
                    </Text>
                  </Box>

                  <Box
                    sx={{
                      height: "50px",
                      borderRadius: "5px",
                    }}
                  >
                    <input
                      type="text"
                      placeholder="Enter EHR Client Secret"
                      value={ehrClientSecret}
                      onChange={(e) => setEhrClientSecret(e.target.value)}
                      style={{
                        height: "50px",
                        width: "100%",
                        padding: "16px",
                        fontSize: "14px",
                        fontWeight: 400,
                        lineHeight: "22px",
                        border: "1px solid #E5E5E5",

                        outline: "none",

                        borderRadius: "8px",
                      }}
                    />
                  </Box>
                </Box>
              </Box>
              <Box sx={{ marginBottom: "24px", width: "100%" }}>
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  {" "}
                  <Text
                    sx={{
                      fontWeight: 600,
                      fontSize: "14px",
                      lineHeight: "21px",
                      marginBottom: "5px",
                      marginRight: "8px",
                    }}
                  >
                    Token URL <span style={{ color: "red" }}>*</span>
                  </Text>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: "8px",
                    }}
                  >
                    <Info />
                  </Box>
                </Box>

                <Box
                  sx={{
                    height: "50px",
                    borderRadius: "8px",
                  }}
                >
                  <input
                    type="text"
                    placeholder="Enter Token Url"
                    value={TokenUrl}
                    onChange={(e) => setTokenUrl(e.target.value)}
                    style={{
                      height: "50px",
                      width: "100%",
                      padding: "16px",
                      fontSize: "14px",
                      fontWeight: 400,
                      lineHeight: "22px",
                      border: "1px solid #E5E5E5",

                      outline: "none",

                      borderRadius: "8px",
                    }}
                  />
                </Box>
              </Box>
              <Box sx={{ marginBottom: "24px", width: "100%" }}>
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  {" "}
                  <Text
                    sx={{
                      fontWeight: 600,
                      fontSize: "14px",
                      lineHeight: "21px",
                      marginBottom: "5px",
                      marginRight: "8px",
                    }}
                  >
                    Scope <span style={{ color: "red" }}>*</span>
                  </Text>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: "8px",
                    }}
                  >
                    <Info />
                  </Box>
                </Box>

                <Box
                  sx={{
                    height: "50px",
                    borderRadius: "8px",
                  }}
                >
                  <input
                    type="text"
                    placeholder="Enter Scope"
                    value={scope}
                    onChange={(e) => setScope(e.target.value)}
                    style={{
                      height: "50px",
                      width: "100%",
                      padding: "16px",
                      fontSize: "14px",
                      fontWeight: 400,
                      lineHeight: "22px",
                      border: "1px solid #E5E5E5",

                      outline: "none",

                      borderRadius: "8px",
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </SharedSectionHeader>
          <SharedSectionHeader
            Heading="Test the connections with your EHR Credentials"
            subHeading=""
          >
            {" "}
            <Box sx={{ height: "40px", width: "150px", marginBottom: "16px" }}>
              <Button
                variant="outline"
                sx={{
                  padding: "9px 20px 9px 20px",
                  color: "#262930",
                  borderRadius: "4px",
                  fontWeight: 500,
                  fontSize: "14px",
                  lineHeight: "20px",
                  display: "flex",

                  height: "40px",
                  width: "150px",
                }}
              >
                Test Connection
              </Button>
            </Box>
          </SharedSectionHeader>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              padding: "16px",
            }}
          >
            <Box sx={{ marginRight: "24px" }}>
              <Button
                onClick={onCancelClick}
                variant="outline"
                sx={{
                  height: "40px",
                  width: "100px",
                  fontSize: "14px",
                  fontWeight: 500,
                  lineHeight: "22px",
                  color: "#1C1C1C",
                }}
              >
                Cancel
              </Button>
            </Box>
            <Box>
              <Button
                disabled={disableButton}
                onClick={onCreateButtonClick}
                sx={{
                  height: "40px",
                  width: "100px",
                  fontSize: "14px",
                  fontWeight: 500,
                  lineHeight: "22px",
                  backgroundColor: "#1B75BC",
                  color: "#FFFFFF",
                }}
              >
                Create
              </Button>
            </Box>
          </Box>
        </ReusableehrLayout>
      </form>
    </Box>
  );
};

export default EhrConnect;
